// Formats a document_types.json key (e.g. "memorandum_of_sale") into a
// display label ("Memorandum Of Sale") for the Add Document Type modal -
// document type entries have no separate "name" field of their own.
export function documentTypeLabel(key: string): string {
  return key
    .split('_')
    .map((word) => (word ? word.charAt(0).toUpperCase() + word.slice(1) : word))
    .join(' ')
}

// What each fixed platform pipeline stage actually does - orchestration
// steps are read-only (constants.ts's PLATFORM_ORCHESTRATION_STEPS), so this
// only ever needs to explain them, never validate/generate one.
export const BASELINE_PROMPT_EMPTY_PLACEHOLDER = 'No baseline prompt set - using extractor default.'

export const ORCHESTRATION_STEP_DESCRIPTIONS: Record<string, string> = {
  validate_request: 'Checks the request has everything it needs before processing starts.',
  identify_document_types: 'Works out what kind of document each uploaded file is.',
  extract_fields: 'Reads the documents and pulls out the configured fields.',
  normalise: 'Cleans up extracted values into a consistent format, like dates and currency.',
  resolve_lookups: 'Matches extracted names against the Lookup Table.',
  resolve_outputs: 'Builds the final response values using the Output Resolution rules.',
  build_response: 'Assembles the finished response to send back.',
}
